import { ArrowBack, Search } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";

export default function SearchInput() {
  const [query, setQuery] = useState("");
  const [active, setActive] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (query) {
      navigate(`/property/search/${query}`);
      setQuery("");
    } else {
      navigate("/");
      setQuery("");
    }
  };

  return (
    <div className="flex">
      <div
        className={`fixed ${
          active
            ? "top-0 left-0 right-0 py-3 bg-[#F7F7F7] z-[99999] px-5"
            : "hidden"
        } md:w-96 md:block md:static md:py-0 md:bg-transparent md:z-0`}
      >
        <div className="flex justify-between">
          <div className="md:hidden">
            <IconButton
              aria-label="search"
              onClick={() => {
                setActive(false);
              }}
            >
              <ArrowBack />
            </IconButton>
          </div>
          <div className="relative w-full max-w-sm">
            <input
              type="search"
              id="search-dropdown"
              className="block p-2.5 w-full text-sm text-gray-900 focus:outline-none bg-gray-50 rounded-md border border-black"
              placeholder="Cari sesuatu..."
              value={query ? query : ""}
              onChange={(e) => {
                setQuery(e.target.value);
              }}
            />
            <button
              type="submit"
              onClick={handleSearch}
              className="absolute top-0 end-0 p-2.5 text-sm font-medium h-full text-white bg-secondary rounded-e-md transition duration-200 hover:bg-black"
            >
              <Search />
            </button>
          </div>
        </div>
      </div>
      <div className="md:hidden">
        <IconButton
          aria-label="search"
          onClick={() => {
            setActive(true);
          }}
        >
          <Search />
        </IconButton>
      </div>
    </div>
  );
}
